import { render, staticRenderFns } from "./ChatBotBusyListForm.vue?vue&type=template&id=490fc05e&"
import script from "./ChatBotBusyListForm.vue?vue&type=script&lang=ts&"
export * from "./ChatBotBusyListForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports